import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserAltService {
  error = new Subject<string>();
  slug = '/user_alts';
  resourceName = 'user_alts';
  allAlts?: any;
  altsBetween?: any;

  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.allAlts) {
      this.allAlts = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allAlts;
  }

  clearCache() {
    this.allAlts = null;
    this.altsBetween = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(alt: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      alt,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, alt: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      alt,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  getGoodAlt(gender) {
    if (gender == 'm') {
      return '≤53';
    }
    if (gender == 'f') {
      return '≤53';
    }
  }

  getTypical(alt, gender) {
    if (gender == 'm') {
      switch (+alt) {
        case 27:
          return '20 - 59';
          break;
        case 26:
          return '60 - 69';
          break;
        case 23:
          return '70 - 80';
          break;
      }
    } else if (gender == 'f') {
      switch (+alt) {
        case 27:
          return '20 - 49';
          break;
        case 24:
          return '50 - 69';
          break;
        case 23:
          return '70 - 80';
          break;
      }
    }
  }

  getRagForSex(alt, sex) {
    let ragColour = '';

   // if (sex == 'm') {
      if (+alt <= 53) {
        ragColour = 'green';
      } else if (+alt >53) {
        ragColour = 'red';
      } /*else {
        ragColour = 'amber';
      }*/
   /* }
    if (sex == 'f') {
      if (+alt <= 19) {
        ragColour = 'green';
      } else if (+alt > 53) {
        ragColour = 'red';
      } else {
        ragColour = 'amber';
      }
    }*/
    return ragColour;
  }

  getAltforColorAndSex(colour: string, sex: string) {
    let ragRange = '';

    if (sex == 'f') {
      if (colour == 'green') {
        ragRange = '≤53';
      } else  {
        ragRange = '>53';
      }
    }
    if (sex == 'm') {
      if (colour == 'green') {
        ragRange = '≤53';
      }  else {
        ragRange = '>61';
      }
    }

    return ragRange;
  }
}
